
export class Measurement
{
    measurementID: number;
    measurementNameName: string;
}